import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Link2, Link2Off, Loader2 } from 'lucide-react';
import { publicOrigin } from '../lib/native';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Creates (or reuses) a public /track/<token> link for a load and copies it to the clipboard.
const ShareEtaButton = ({ loadId, shareToken, onChange, compact = false }) => {
  const [busy, setBusy] = useState(false);
  const [token, setToken] = useState(shareToken || null);

  const share = async () => {
    setBusy(true);
    try {
      const r = await axios.post(`${API}/tracking/loads/${loadId}/share`, {}, { withCredentials: true });
      const url = `${publicOrigin()}${r.data.path}`;
      setToken(r.data.token);
      onChange?.(r.data.token);
      try { await navigator.clipboard.writeText(url); toast.success('Customer ETA link copied', { description: url }); }
      catch { toast.success('Customer ETA link ready', { description: url, duration: 10000 }); }
    } catch (e) { toast.error(e?.response?.data?.detail || 'Could not create link'); } finally { setBusy(false); }
  };
  const revoke = async () => {
    if (!window.confirm('Revoke this tracking link? Anyone with it will lose access.')) return;
    setBusy(true);
    try {
      await axios.delete(`${API}/tracking/loads/${loadId}/share`, { withCredentials: true });
      setToken(null); onChange?.(null); toast.success('Tracking link revoked');
    } catch (e) { toast.error(e?.response?.data?.detail || 'Could not revoke'); } finally { setBusy(false); }
  };

  const base = compact ? 'text-slate-500 hover:text-[#002FA7]' : 'inline-flex items-center gap-1 px-2 py-1 rounded-md border text-xs font-semibold';
  return (
    <span className="inline-flex items-center gap-1">
      <button type="button" data-testid={`share-eta-${loadId}`} onClick={share} disabled={busy}
              title={token ? 'Copy customer ETA link' : 'Create customer ETA link'}
              className={`${base} ${!compact ? (token ? 'border-emerald-300 text-emerald-700 bg-emerald-50' : 'border-slate-300 text-slate-700 hover:bg-slate-50') : ''}`}>
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Link2 className={`w-4 h-4 ${compact && token ? 'text-emerald-600' : ''}`} />}
        {!compact && (token ? 'Copy ETA link' : 'Share ETA link')}
      </button>
      {token && (
        <button type="button" data-testid={`revoke-eta-${loadId}`} onClick={revoke} disabled={busy} title="Revoke customer link"
                className={compact ? 'text-slate-400 hover:text-red-600' : 'inline-flex items-center px-1.5 py-1 rounded-md border border-slate-200 text-slate-500 hover:text-red-600'}>
          <Link2Off className="w-4 h-4" />
        </button>
      )}
    </span>
  );
};

export default ShareEtaButton;
